import { getLocale } from "../runtime";

const sv_viewcampaigndetails = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Visa kampanjdetaljer`
};

const viewcampaigndetails = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_viewcampaigndetails(inputs)
	return "viewCampaignDetails";
};

export { viewcampaigndetails as "viewCampaignDetails" };